export default __webpack_public_path__ + "static/holiday-banner-image-1143b8c506180381bb8ebc61eeb0cd7f.svg";